import styled from 'styled-components';

import history from 'utils/browserHistory';

const Title = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
`;

const StyledLink = styled.a`
  color: blue;
  cursor: pointer;
  font-size: 12px;
  text-decoration: underline;
  :hover {
    color: blue;
    cursor: pointer;
    text-decoration: underline;
  }
`;

const CopyOperationSuccessNotification = ({ id, name }) => {
  return (
    <div>
      <Title>{`Duplicated to ${name}`}</Title>
      <StyledLink onClick={() => history.push(`/processes/operations/${id}`)}>
        Go To Operation
      </StyledLink>
    </div>
  );
};

export default CopyOperationSuccessNotification;
